<template>
  <div>
    <Navbar ref="navbarRef" :selectedOption="1" />
    <h4></h4>
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td class="centro">
              <button type="submit" class="btn btn-light" @click.prevent="getDataPagina(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td class="centro">
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">Observación</th>
          <th scope="col">ElementoNombre</th>
          <th scope="col">DosisNombre</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="dosismed in datosPaginados" :key="dosismed.idDosisMed">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(dosismed.idDosisMed)" title="Editar">edit_square</i></td>
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirEditar(dosismed.idDosisMed)" title="Editar">edit_square</i></td>
          <td>{{dosismed.observacion}}</td>
          <td>{{dosismed.elementoNombre}}</td>
          <td>{{dosismed.dosisNombre}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deleteDosisMed(dosismed.idDosisMed)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPagina(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idDosisMed" class="form-label">IdDosisMed</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idDosisMed" name="idDosisMed" v-model="datoDosisMed.idDosisMed" disabled>
                </div>
              </div>
            </div>
<!-- Botón Lista de Valores  Elemento -->
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idElemento" class="form-label"> Elemento</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idElemento" name="idElemento" v-model="datoDosisMed.idElemento">
                      <option v-for="elemento in elementos" :value="elemento.idElemento" :key="elemento.idElemento">
                        {{ elemento.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
            </div>
<!-- Botón Lista de Valores  Elemento -->
<!-- Botón Lista de Valores  Dosis -->
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idDosis" class="form-label"> Dosis</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idDosis" name="idDosis" v-model="datoDosisMed.idDosis">
                      <option v-for="dosis in dosiss" :value="dosis.idDosis" :key="dosis.idDosis">
                        {{ dosis.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
            </div>
<!-- Botón Lista de Valores  Dosis -->
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="observacion" class="form-label">Observación</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="observacion" name="observacion" v-model="datoDosisMed.observacion" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
<!--
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
-->
        <button type="submit" class="btn btn-light" @click.prevent="guardarDosisMed" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditDosisMed" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
    <Footer/>
  </div>
</template>
<script>
import Navbar from '../../components/Navbar.vue'
import Footer from '../../components/Footer.vue'
import { validarForm } from '../../modules/validacionesForms.js'
import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Navbar, Footer
  },
  data () {
    return {
      dosismeds : [],
      datoDosisMed : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true,
      elementos: [],
      dosiss: [],
      estiloImagen: {
        width: "200px",
        height: "200px"
      }
    }
  },
  mounted () {
    this.getDataPaginaTodos(this.paginaActual)
    this.$refs.navbarRef.toggleProcesos()
    this.$refs.navbarRef.toggleReportes()
    this.$refs.navbarRef.toggleParametros()
    this.$refs.navbarRef.toggleAyuda()
    this.fetchElementos()
    this.fetchDosiss()
  },
  methods : {
    totalPaginas(){
      return Math.ceil(this.dosismeds.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwdosismeds/nombre/'+this.nombreBusqueda).then(response=>{
          this.dosismeds=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.dosismeds.slice(ini,fin);
        });
      }
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwdosismeds').then(response=>{
      this.dosismeds=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.dosismeds.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarForm(){
      const requiredFields = [
        'idElemento'
        ,'idDosis'
        ,'observacion'
      ];
      const requiredFieldsText = [
        'idElemento'
        ,'idDosis'
        ,'observacion'
      ];
      return validarForm(this.datoDosisMed, requiredFields, requiredFieldsText);
    },
    async guardarDosisMed(){
      if(this.validarForm() === 1){
        try {
          await api.post('/dosismeds', this.datoDosisMed)
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "DosisMed creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditDosisMed(){
      if(this.validarForm() === 1){
        try {
          await api.post('/dosismeds', this.datoDosisMed)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "DosisMed creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoDosisMed={}
      this.titulo   = 'Crear '
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirModalEditar(idDosisMed){
      this.modalWindow = true
      if(idDosisMed != null){    
           api.get('/vwdosismeds/'+idDosisMed).then(resp=>{
          this.datoDosisMed = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar '
      this.btnCrear = false
      this.btnEditar= true
    },
    abrirEditar(idDosisMed){
      if(idDosisMed != null){
        this.$router.push('/dosismedmd/'+idDosisMed)
      }
    },
    async deleteDosisMed (idDosisMed) {
      try{
        await api.delete('/dosismeds/'+idDosisMed)
          this.getDataPagina(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
    fetchElementos() {
      fetch('http://localhost:8080/api/v1/elementos')
        .then(response => response.json())
        .then(data => {
          this.elementos = data;
        })
        .catch(error => {
          console.error('Error fetching elementos:', error);
        });
    },
    fetchDosiss() {
      fetch('http://localhost:8080/api/v1/dosiss')
        .then(response => response.json())
        .then(data => {
          this.dosiss = data;
        })
        .catch(error => {
          console.error('Error fetching dosiss:', error);
        });
    },
  },
}
</script>
<style src="@/assets/css/listaFiltrada.css" scoped></style>
